module.exports = __webpack_public_path__ + "./images/15a40fbd43a0b05c75512b3dfd946ccd.webp";